import { createSlice } from '@reduxjs/toolkit';
import { fetchTeamEvents, fetchRemoteCalendar, fetchPermissionToCreateUserEvents } from '../thunks/calendarThunks.js';

const initialState = {
    teamEvents: {
        vacations: [],
        overtimes: [],
        sickLeaves: [],
        workingDays: [],
    },
    remoteCalendarId: {
        id: '',
        error: '',
    },
    enableCreateEvents: false,
};

const calendarSlice = createSlice({
    name: 'calendar',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTeamEvents.fulfilled, (state, action) => {
                state.teamEvents = action.payload;
            })
            .addCase(fetchRemoteCalendar.fulfilled, (state, action) => {
                state.remoteCalendarId = {
                    id: action.payload,
                    error: '',
                };
            })
            .addCase(fetchRemoteCalendar.rejected, (state, action) => {
                state.remoteCalendarId = {
                    id: '',
                    error: action.payload || action.error?.message,
                };
            })
            .addCase(fetchPermissionToCreateUserEvents.fulfilled, (state, action) => {
                state.enableCreateEvents = action.payload;
            })
            .addCase(fetchPermissionToCreateUserEvents.rejected, (state) => {
                state.enableCreateEvents = false;
            })
            .addDefaultCase((state) => state);
    },
});

export default calendarSlice.reducer;
